import { useId } from 'react'

type Props = {
  className?: string
  reverse?: boolean
}

export const Divider = ({ className, reverse }: Props) => {
  const id = useId()

  return (
    <svg
      className={className}
      viewBox="0 0 307 21"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M0.5 20H133.5C144.546 20 153.5 11.0457 153.5 0C153.5 11.0457 162.454 20 173.5 20H306.5"
        stroke={`url(#${id})`}
        style={{
          transform: reverse ? 'rotate(180deg)' : '',
          transformOrigin: 'center center',
        }}
      />
      <defs>
        <radialGradient
          id={id}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(153.5 3.69047) scale(153 6491.49)"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" />
        </radialGradient>
      </defs>
    </svg>
  )
}
